query AssistantConversationsList(
  $page: Int
  $rowsPerPage: Int
  $filter: AssistantConversationsFilterInput
) {
  assistantConversations(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      topic
      hasRequest
      messageCount
      lastMessageAt
      user {
        id
        email
      }
    }
  }
}
